<template>
  <!--
    Kontener zakładek predefiniowanych filtrów:
    - 'preselect-tabs': główny div opakowujący
    - dynamiczna klasa 'step' do stylizacji w zależności od kroku
  -->
  <div class="preselect-tabs">
    <!--
      Nawigacja jako pigułki (pills):
      - flex-column dla układu pionowego na małych ekranach
      - flex-sm-row dla układu poziomego na większych ekranach
    -->
    <nav class="nav nav-pills flex-column flex-sm-row">
      <!--
        Generowanie każdej zakładki:
        - 'store.preselectTabs': tablica identyfikatorów lub kluczy tłumaczeń
        - :class aktywna dla bieżąco wybranej zakładki
        - @click wywołuje zmianę filtra
      -->
      <div
        class="flex-sm-fill text-sm-center nav-link"
        :class="[{ active: isActive(index) }]"
        v-for="(item, index) in store.preselectTabs"
        :key="index"
        @click="setFilters(index)"
      >
        <!-- Wyświetlenie przetłumacowanej nazwy zakładki -->
        {{ t(item) }}
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "PreselectTabs", // Nazwa komponentu w Vue DevTools
  props: {
    // Store Pinia z danymi filtrów predefiniowanych
    store: { required: true },
  },
  methods: {
    /**
     * Ustawia aktywną zakładkę predefiniowaną
     * @param {number} index - indeks wybranej zakładki
     */
    setFilters(index) {
      this.store.setPreselectTab(index);
    },
    /**
     * Sprawdza, czy dana zakładka jest aktywna
     * @param {number} id - indeks zakładki
     * @returns {boolean}
     */
    isActive(id) {
      return this.store.preselectActiveTab === id;
    },
  },
};
</script>

<style scoped>
/* Zakładki predefiniowanych zestawów filtrów — jeden pasek, aktywna pozycja
   oznaczona wskaźnikiem u dołu (spójnie z nawigacją globalną). */
.preselect-tabs {
  width: 100%;
  min-width: 0;
}

.preselect-tabs .nav {
  gap: 0;
  background: var(--surface-primary);
  border: 1px solid var(--border-default);
  border-radius: var(--panel-radius);
  overflow: hidden;
}

.preselect-tabs .nav .nav-link {
  padding: var(--spacing-md) var(--spacing-lg);
  border-right: 1px solid var(--border-default);
  border-radius: var(--control-radius);
  color: var(--text-secondary);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  letter-spacing: var(--letter-spacing-caps);
  text-transform: uppercase;
  cursor: pointer;
  margin: 0;
  transition: background-color var(--transition-fast), color var(--transition-fast);
}

/* Brak obramowania po prawej dla ostatniej zakładki */
.preselect-tabs .nav .nav-link:last-child {
  border-right: 0;
}

.preselect-tabs .nav .nav-link:hover {
  background: var(--surface-hover);
  color: var(--text-primary);
  text-decoration: none;
}

/* Aktywna zakładka — wyraźna, bez podkreślenia tekstu */
.preselect-tabs .nav .nav-link.active {
  background: var(--surface-secondary);
  color: var(--text-primary);
  font-weight: var(--font-weight-bold);
  text-decoration: none;
  box-shadow: inset 0 -3px 0 var(--surface-inverse);
}
</style>
